/* Horizontal product rail with previous / next buttons. */
(function () {
  document.querySelectorAll('[data-rail-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('data-rail-target'));
      if (!target) return;
      var dir = parseInt(btn.getAttribute('data-rail-btn'), 10);
      target.scrollBy({ left: dir * target.clientWidth * 0.5, behavior: 'smooth' });
    });
  });
})();
